<template>
  <div :class="{backstage: $route.path !== '/',image_body:$route.path == '/'}" id="app">
        <component v-if="$route.path!=='/'" :is="currentTopComponent" />
        <div id="total_content">
        <router-view/>
      </div>
      <component v-if="$route.path!=='/'" :is="currentFooterComponent" />
  </div>
</template>

<script>
  import Top from '@/components/top'
  import Footer from '@/components/footer'
  import EnTop from '@/components/en_top'
  import EnFooter from '@/components/en_footer'
  export default {
  components:{
    Top,
    Footer,
    EnTop,
    EnFooter
  },
  computed:{
    // 计算属性来决定当前应该使用哪个 Top 组件
    currentTopComponent() {
      return this.$route.path.startsWith('/en') ? 'EnTop' : 'Top';
    },
    // 计算属性来决定当前应该使用哪个 Footer 组件
    currentFooterComponent() {
      return this.$route.path.startsWith('/en') ? 'EnFooter' : 'Footer';
    }
  }
}
</script>

<style>
 .image_body{
    background:url(@/assets/images/index_top_bg.jpg) repeat-x;
 }
</style>
